var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("notificationModalController", [
    "$rootScope",
    "$scope",
    "$window",
    "modalService",
    "cartService",
    "$timeout",
    "validationService",
    "loaderService",
    function (
        $rootScope,
        $scope,
        $window,
        modalService,
        cartService,
        $timeout,
        validationService,
        loaderService
    ) {
        //#region Fields

        //#region Notification Modal
        $scope.notificationModal = {
            callbackOnCloseEmitName: null,
            callbackOnCloseFunc: null,
            callbackOnOkEmitName: null,
            callbackOnOkFunc: null,
            data: [],
            hideClose: false,
            modalKey: null,
            redirectOnOkUrl: null,
            redirectOnCloseUrl: null,
        };

        // New fields to store email values
        $scope.txtEmail = "";
        $scope.txtConfirmEmail = "";
        $scope.validationMessage = "";
        $scope.isValidForm = true;
        $scope.enableGuestCheckout = window.__env.enableGuestCheckout;
        $scope.regularExpressions = validationService.getRegularExpressions();
        $scope.showGuestCheckout = false;
        //#endregion

        //#endregion

        //#region Events

        //#region Notification Modal
        $rootScope.$on("CloseNotificationModal", function (event) {
            event.stopPropagation();
            modalService.close("notificationModal");
        });

        $rootScope.$on(
            "ShowNotificationModal",
            function (event, notificationModal) {
                event.stopPropagation();
                $timeout(function () {
                    $scope.notificationModal = angular.copy(notificationModal);
                });

                if (notificationModal.modalKey == "loginOptions") {
                    cartService.getCustomerCart().then(function (cart) {
                        $scope.freeOrder = false;
                        if (cart.data) {
                            var cartData = cart.data;
                            var totalListPrice = cartData.reduce(function (
                                total,
                                item
                            ) {
                                return total + item.listPrice.amount;
                            },
                            0);
                            if (totalListPrice == 0) {
                                $scope.freeOrder = true;
                            }
                            modalService.open("notificationModal");
                        }
                    });
                } else {
                    modalService.open("notificationModal");
                }
            }
        );
        //#endregion

        //#endregion

        //#region Functions

        //#region Notification Modal
        $scope.close = function () {
            if (!$scope.notificationModal.hideClose) {
                modalService.close("notificationModal");
                if ($scope.notificationModal.redirectOnCloseUrl)
                    $window.location.href =
                        $scope.notificationModal.redirectOnCloseUrl;
                else if ($scope.notificationModal.callbackOnCloseEmitName)
                    $rootScope.$emit(
                        $scope.notificationModal.callbackOnCloseEmitName
                    );
                else if ($scope.notificationModal.callbackOnCloseFunc)
                    $scope.notificationModal.callbackOnCloseFunc();
            }
        };

        $scope.ok = function () {
            // Store the email values in $rootScope
            $rootScope.txtEmail = $scope.txtEmail;
            $rootScope.txtConfirmEmail = $scope.txtConfirmEmail;

            modalService.close("notificationModal");
            if ($scope.notificationModal.redirectOnOkUrl)
                $window.location.href =
                    $scope.notificationModal.redirectOnOkUrl;
            else if ($scope.notificationModal.callbackOnOkEmitName)
                $rootScope.$emit($scope.notificationModal.callbackOnOkEmitName);
            else if ($scope.notificationModal.callbackOnOkFunc)
                $scope.notificationModal.callbackOnOkFunc();
        };

        $scope.validateEmails = function () {
            $scope.validationMessage = "";
            $scope.isValidForm = true;
            $scope.txtEmail = document.getElementById("txtEmaile").value;
            $scope.txtConfirmEmail =
                document.getElementById("txtConfirmEmaile").value;
            if (!$scope.txtEmail || !$scope.txtConfirmEmail) {
                $scope.validationMessage =
                    "Both email fields are required and must match.";
                $scope.isValidForm = false;
                return;
            }

            var emailPattern = $scope.regularExpressions.email;
            if (!emailPattern.test($scope.txtEmail)) {
                $scope.validationMessage =
                    "Please enter a valid email address.";
                $scope.isValidForm = false;
                return;
            }

            if (
                $scope.txtEmail.toLowerCase() !=
                $scope.txtConfirmEmail.toLowerCase()
            ) {
                $scope.validationMessage =
                    "Email addresses do not match. Please check and try again.";
                $scope.isValidForm = false;
                return;
            }
        };

        $scope.proceedToGuestCheckout = function () {
            loaderService.show();
            $scope.validateEmails();
            if (!$scope.isValidForm) {
                loaderService.hide();
                return;
            } else {
                cartService
                    .guestCheckoutAccess(
                        document.getElementById("txtEmaile").value
                    )
                    .then(
                        function (response) {
                            if (response.data.toLowerCase() == 'true') {
                                $window.location.href =
                                    "/cart/checkout/shipping";
                            }
                            else if(response.data.toLowerCase() == 'userexists'){
                                $scope.validationMessage =
                                    "This email address is already registered. Please login to your account to continue with checkout.";
                                    $scope.isValidForm = false;
                                    loaderService.hide();
                            }
                             else {
                                $scope.validationMessage =
                                    "Guest checkout is not available. Please create an account to proceed with checkout.";
                                $scope.isValidForm = false;
                                loaderService.hide();
                            }
                        },
                        function (error) {
                            $scope.validationMessage =
                                "Error processing request. Please try again.";
                            $scope.isValidForm = false;
                            loaderService.hide();
                        }
                    );
            }
        };

        $scope.closeAndRedirectToCart = function () {
            modalService.close("notificationModal");
            $window.location.href = "/cart";
        };
        $scope.saveOrder = function () {
            $rootScope.$emit("SaveOrder");
        };
        $scope.closeAndRedirectToLogin = function () {
            modalService.close("notificationModal");
            $window.location.href = "/account/login";
        };
        $scope.proceedToShowGuestCheckout = function () {
            $scope.showGuestCheckout = true;
        };

        $scope.saveOrder = function () {
            $rootScope.$emit("SaveOrder");
        };
        
        //#endregion
    },
]);
